import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Reminder = forwardRef<SVGSVGElement, SvgIconProps>(
  function Reminder(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M16.677 6.973a5.506 5.506 0 011.802 2.721c.125.444.188.903.188 1.364a5.094 5.094 0 01-.934 2.9 6.935 6.935 0 01-.923 1.034 26.57 26.57 0 01-3.145 2.607 8.93 8.93 0 01-1.61.962 1.64 1.64 0 01-.4.104.168.168 0 01-.191-.16 1.277 1.277 0 01.027-.494c.026-.218.076-.435.076-.653a.608.608 0 00-.571-.68 6.965 6.965 0 01-3.796-1.68 5.312 5.312 0 01-1.719-2.784A4.905 4.905 0 016.1 8.386a6.044 6.044 0 012.25-2.12 6.97 6.97 0 012.207-.8c.366-.06.735-.1 1.105-.12a7.305 7.305 0 012.551.305 6.823 6.823 0 012.464 1.322zm-4.048 1.46c.53-.54.13-1.433-.628-1.433a.882.882 0 00-.615.247v.001a.832.832 0 00-.015 1.184c-1.209.28-2.106 1.344-2.106 2.594v.996c0 1.236-.843 1.472-.528 1.734.133.11 1.208.29 1.544.332 1.51.187 3.484.131 4.916-.295a.19.19 0 00.09-.305c-.66-.777-.55-1.511-.55-2.462 0-1.25-.897-2.313-2.108-2.593zm-1.282 6.679c.506.473 1.385.142 1.385-.552a.209.209 0 00-.21-.207h-1.206c-.317 0-.25.495.031.759z" />
      </SvgIcon>
    )
  },
)

export default Reminder
